var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 20C7.5 20 15 10.9573 15 7.05882C15 3.16034 11.4765 0 7.5 0C3.52355 0 0 3.16034 0 7.05882C0 10.9573 7.5 20 7.5 20ZM7.49998 10.5884C9.15683 10.5884 10.5 9.2716 10.5 7.64723C10.5 6.02286 9.15683 4.70605 7.49998 4.70605C5.84312 4.70605 4.49998 6.02286 4.49998 7.64723C4.49998 9.2716 5.84312 10.5884 7.49998 10.5884Z",
    fill: "#373B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMarker);
export default __webpack_public_path__ + "static/media/default_marker.a88d330267f71d475834e42e817a1261.svg";
export { ForwardRef as ReactComponent };